import React from 'react';
import { Spin } from 'antd';
import astronaut from '@assets/images/astronaut-story.png';
import { BsBookmarkFill, BsStarFill, BsLightbulbFill } from 'react-icons/bs';
import { BiSolidDownload } from 'react-icons/bi';
import { CgInsights } from 'react-icons/cg';
import { FaUser, FaHashtag, FaShareAlt, FaComment } from 'react-icons/fa';
import { MdRequestPage } from 'react-icons/md';
import styles from './index.module.scss';

interface StoryButtonsProps {
  isMobile?: boolean;
  isOwnerStory: boolean;
  onLearningInsight?: () => void;
  onRate?: () => void;
  onRecommendedStories?: () => void;
  onDownload?: () => void;
  isDownloadLoading?: boolean;
  onActivity?: () => void;
  onHashtag?: () => void;
  onStoryRequest?: () => void;
  isStoryRequestLoading?: boolean;
  isRecommendedStoriesLoading?: boolean;
  handleOpenStoryInsight: () => void;
  isVisibleStoryInsight: boolean;
}

const StoryButtons: React.FC<StoryButtonsProps> = ({
  isMobile = false,
  isOwnerStory = false,
  onLearningInsight,
  onRate,
  onRecommendedStories,
  onDownload,
  handleOpenStoryInsight,
  isVisibleStoryInsight,
  onActivity,
  onHashtag,
  onStoryRequest,
  isDownloadLoading = false,
  isStoryRequestLoading = false,
  isRecommendedStoriesLoading = false,
}) => {
  const allButtons = [
    {
      icon: <BsLightbulbFill size={isMobile ? 20 : 24} />,
      text: 'Learning Insight',
      onClick: onLearningInsight,
      // Placeholder for image - replace with actual image path
      image: null, // 'path/to/learning-insight-icon.png'
      showOnlyForOwner: false,
      isLoading: false,
      disabled: false,
    },
    {
      icon: <BsLightbulbFill size={isMobile ? 20 : 24} />,
      text: 'Activity',
      onClick: onActivity,
      // Placeholder for image - replace with actual image path
      image: null, // 'path/to/learning-insight-icon.png'
      showOnlyForOwner: false,
      isLoading: false,
      disabled: false,
    },
    {
      icon: <BsBookmarkFill size={isMobile ? 20 : 24} />,
      text: 'Recommended Stories',
      onClick: onRecommendedStories,
      // Placeholder for image - replace with actual image path
      image: null, // 'path/to/recommended-stories-icon.png'
      showOnlyForOwner: false,
      isLoading: isRecommendedStoriesLoading,
      disabled: false,
    },
    {
      icon: <BiSolidDownload size={isMobile ? 20 : 24} />,
      text: 'Download',
      onClick: onDownload,
      image: null,
      showOnlyForOwner: false,
      isLoading: isDownloadLoading,
      disabled: false,
    },
    {
      icon: <FaShareAlt size={isMobile ? 20 : 24} />,
      text: 'Share',
      onClick: onDownload,
      image: null,
      showOnlyForOwner: false,
      isLoading: isDownloadLoading,
      disabled: true,
    },
    {
      icon: <MdRequestPage size={isMobile ? 20 : 24} />,
      text: 'Story Request',
      onClick: onStoryRequest,
      image: null,
      showOnlyForOwner: false,
      isLoading: isStoryRequestLoading,
      disabled: false,
    },
    {
      icon: <BsStarFill size={isMobile ? 20 : 24} />,
      text: 'Rate',
      onClick: onRate,
      // Placeholder for image - replace with actual image path
      image: null, // 'path/to/rate-icon.png'
      showOnlyForOwner: false,
      isLoading: false,
      disabled: false,
    },
    {
      icon: <FaComment size={isMobile ? 20 : 24} />,
      text: 'Comment',
      onClick: () => {
        // TODO: Implement comment functionality
      },
      image: null,
      showOnlyForOwner: false,
      isLoading: isDownloadLoading,
      disabled: true,
    },
    {
      icon: <FaHashtag size={isMobile ? 20 : 24} />,
      text: 'Hashtag',
      onClick: onHashtag,
      image: null,
      showOnlyForOwner: false,
      isLoading: isDownloadLoading,
      disabled: false,
    },
    {
      icon: <FaUser size={isMobile ? 20 : 24} />,
      text: 'User',
      onClick: () => {
        // TODO: Implement user functionality
      },
      image: null,
      showOnlyForOwner: false,
      isLoading: isDownloadLoading,
      disabled: true,
    },
    {
      icon: <CgInsights size={isMobile ? 20 : 24} />,
      text: 'Story Insight',
      onClick: handleOpenStoryInsight,
      image: null,
      showOnlyForOwner: false,
      isLoading: false,
      disabled: false,
    },
  ];

  const buttons = allButtons.filter(
    (button) =>
      !button.showOnlyForOwner || (button.showOnlyForOwner && isOwnerStory),
  );

  return (
    <div className={styles.stroyActions}>
      {!isMobile && (
        <div className={styles.image}>
          <img src={astronaut} alt="astronaut" />
        </div>
      )}

      <div
        className={`${styles.storyButtons} ${isMobile ? styles.mobile : styles.desktop}`}>
        {buttons.map((button, index) => (
          <button
            key={index}
            className={`${styles.button} ${button.isLoading ? styles.loading : ''}`}
            onClick={button.onClick}
            disabled={button.disabled || button.isLoading}>
            <div className={styles.icon}>
              {button.isLoading ? (
                <Spin size="small" />
              ) : button.image ? (
                <img src={button.image} alt={button.text} />
              ) : (
                button.icon
              )}
            </div>
            <span className={styles.text}>
              {button.isLoading ? 'Checking...' : button.text}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StoryButtons;
